import axios from 'axios';
// eslint-disable-next-line import/no-extraneous-dependencies
import qs from 'qs';
import { getToken } from '@/utils/auth';
import router from '@/router';

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 1000 * 60 * 2, // request timeout
});

export function normalizeRequestError(error) {
  if (error && error.isNormalizedRequestError) return error;
  const response = error && error.response;
  const data = response
    ? (response.data === undefined ? null : response.data)
    : ((error && error.data) || null);
  const status = response ? response.status : ((error && error.status) || null);
  const canceled = !!(axios.isCancel && axios.isCancel(error));
  const timedOut = !!(error && error.code === 'ECONNABORTED');
  let message = data && typeof data === 'object' ? data.message : '';
  if (!message && error && error.message) message = error.message;
  if (canceled) message = message || '请求已取消';
  if (timedOut) message = '请求超时，请稍后重试';
  if (!message) message = response ? '请求失败，请稍后重试' : '网络连接失败，请检查网络';
  return {
    isNormalizedRequestError: true,
    message,
    status,
    data,
    code: (error && error.code) || null,
    canceled,
    original: error || null,
  };
}

// axios.defaults.baseURL = process.env.BASE_API;
// // 请求超时时间
// axios.defaults.timeout = 10000;
// // post请求头
// service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// request interceptor
// service.defaults.withCredentials=true;
service.interceptors.request.use(
  config => {
    config.headers['X-YJ-Mobile-Token'] = getToken();
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    return Promise.reject(normalizeRequestError(error));
  },
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.status == true) {
      return Promise.resolve(response);
    }
    if (res.code == 12) {
      // 未登录
      router.replace({ name: 'login' });
    }
    return Promise.resolve(response);
  },
  // 服务器状态码不是200的情况
  error => {
    const normalizedError = normalizeRequestError(error);
    if (normalizedError.status) {
      switch (normalizedError.status) {
      // 502服务器错误
      case 502:
        // router.replace({ name: 'not505' });
        break;
        // 404请求不存在
      case 404:
        // router.replace({ name: 'not404' });
        break;
        // 其他错误，直接抛出错误提示
      default:
        if (normalizedError.data && normalizedError.data.message) {
          alert(normalizedError.data.message);
        }
      }
    }
    return Promise.reject(normalizedError);
  },
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params,
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(normalizeRequestError(err));
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function post(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, qs.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(normalizeRequestError(err));
      });
  });
}

export function postJson(url, params) {
  return new Promise((resolve, reject) => {
    service.post(url, params, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(normalizeRequestError(err));
      });
  });
}

export function postupload(url, params) {
  const config = {
    // 添加请求头
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  return new Promise((resolve, reject) => {
    service.post(url, params, config)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(normalizeRequestError(err));
      });
  });
}

/**
 * delect方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function delect(url, params) {
  return new Promise((resolve, reject) => {
    service.delete(url, {
      params,
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(normalizeRequestError(err));
      });
  });
}

/**
 * putJson方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function putJson(url, params) {
  return new Promise((resolve, reject) => {
    service.put(url, params, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(normalizeRequestError(err));
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js